module.exports = __webpack_public_path__ + "static/media/reset-pwd-bottom-right-shape.9d0a1831.png";